export const IMAGE_FORMAT_JPEG = 'jpeg';

export const IMAGE_FORMAT_PNG = 'png';

export const IMAGE_FORMAT_WEBP = 'webp';
